import countries from '../../core/countries.en.json';
import provinces from '../../core/provinces.en.json';

export default {
  countries,
  provinces,
};
